/**
 * 因为之前没有用vuex
 * 所以该文件用来表示相关api处理
 */
import api from '@/axios/api';
import { definitions } from '@/types/api';
import { message } from 'ant-design-vue';
import { uniqueId } from 'lodash';
import { QuestionI } from '../question/js/interface';

/**
 * quesiont-module - del
 * @param id
 */
export const delCustomQuestionModuleIds = async (ids: Set<string>) => {
  try {
    console.log(ids, Array.from(ids), 'this is ids');
    if (Array.from(ids).length > 0) await api.delCustomQuestionModule(Array.from(ids));
    // const { data } = await api.delCustomQuestionModule(Array.from(ids));
    // console.log(data, 'del ids data');
  } catch (error) {
    console.log(error);
  }
};

/**
 * 递归调用接口，防止上一个接口没请求完，又调用了新的接口——数据库同时操作同一行
 * @param list
 */
const recursionCustomQuestion = async (list: definitions['CustomQuestionModule'][]) => {
  if (list && list.length > 0) {
    /** 获取第一个，这样不会更改原数组 */
    const [customQuestion, ...questionS] = list;
    try {
      await api.editCustomQuestionModule(customQuestion);
    } catch (error) {
      console.log(error);
    }
    await recursionCustomQuestion(questionS);
  }
};

/**
 * question-module - save
 * @param editList 要保存的list
 */
export const editCustomQuestionModule = async (editList: definitions['CustomQuestionModule'][], _isUnit = false) => {
  try {
    await recursionCustomQuestion(editList);
    if (!_isUnit) message.success('保存成功'); /** 如果是第一次，则不用提示 */
  } catch (error) {
    console.log(error);
  }
};

/**
 * 问题模块 - question-module - list by analysissId
 * @param moduleId
 */
export const listCustomQuestionModuleByCaId = async (moduleId: string): Promise<(definitions['CustomQuestionModule']&{uid: string})[] | null> => {
  try {
    if (moduleId) {
      const { data: { data } } = await api.listCustomQuestionModuleByCaId(moduleId);
      return data.map((v: definitions['CustomQuestionModule']) => ({ ...v, uid: uniqueId('') }));
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/** ==========题目部分================= */

/** question-list-column */
export const questionColumn = [
  {
    title: '题号',
    slots: {
      customRender: 'index',
    },
    width: '10%',
  },
  {
    title: '题目类型',
    key: 'questionType',
    dataIndex: 'questionType',
    width: '10%',
    slots: {
      customRender: 'questionType',
    },
  },
  {
    title: '分值',
    key: 'score',
    dataIndex: 'score',
    width: '10%',
  },
  {
    title: '题目',
    key: 'stem',
    ellipsis: true,
    dataIndex: 'stem',
  },
  {
    title: '操作',
    width: '18%',
    align: 'center',
    slots: {
      customRender: 'operation',
    },
  },
];

/**
 * question-list - list by moduleId
 * @param moduleId 模块id
 */
export const listCustomQuestionByMId = async (moduleId: string): Promise<definitions['CustomQuestion'][]> => {
  try {
    const { data: { data } } = await api.listCustomQuestionByMId(moduleId);
    return data || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

/** 根据uid和模块list，获得模块id */
export const getModuleId = (uid: string, moduleList: []) => {
  console.log();
  return moduleList.find((mo: {uid: string}) => mo.uid === uid) as unknown as definitions['CustomQuestionModule']&{id: string};
};

/**
 * 题目 - edit
 * @param formData
 * @param _isSingle 是否是单个编辑-单个编辑直接提示，多个则在递归中提示最后一个
 * @remark @Transient 可以不传-因为是教师创建题目，所以这里不传stuQuestionAnswer
 */
export const editCustomQuestion = async (formData: QuestionI&{assignmentId: string; moduleId: string}, _isSingle = true) => {
  try {
    const { data } = await api.editCustomQuestion({
      analysis: formData.analysis, // '答案解析',
      answer: formData.answer, // '[1,0,0]/参考答案',
      assignmentId: formData.assignmentId, // '作业Id',
      id: formData.id || undefined, // 'string',
      metas: formData.metas, // '[A选项内容,B选项内容,C选项内容]',
      moduleId: formData.moduleId, // '模块Id',
      questionType: formData.questionType, // 0,
      score: formData.score, // 5,
      seq: formData.seq, // 5,
      stem: formData.stem, // '题干',
    });
    if (data.success && _isSingle) {
      message.success('保存成功'); // 单个编辑需要提示信息，如果是多个同时操作的，只需要提示最后一个
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * 题目 - dels - 批量删除
 * @param id id|ids
 */
export const delCustomQuestionIds = async (id: string|string[]) => {
  try {
    let ids: string[] = id as string[];
    if (!Array.isArray(id)) ids = [id];
    const { data } = await api.delCustomQuestionIds(ids);
    if (data.success) {
      message.success('删除成功');
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * 题目 - seq - 批量修改seq
 * @param list
 */
export const editsSeqCustomQuestion = async (list: QuestionI[]) => {
  try {
    const { data } = await api.editsSeqCustomQuestion(list.map((v: QuestionI) => ({ id: v.id, seq: v.seq })) as []);
    console.log(data, 'this is editsSeqCustomQuestion api res');
  } catch (error) {
    console.log(error);
  }
};

/**
 * 题目 - seq - 批量修改moduleId
 * @param list
 */
export const editsModuleIdCustomQuestion = async (mId: string, ids: string[]) => {
  try {
    const { data } = await api.editsModuleIdCustomQuestion(ids.map((id: string) => ({ id, moduleId: mId })) as []);
    console.log(data, 'this is editsSeqCustomQuestion api res');
    if (data.success) {
      message.success('移动成功');
    }
  } catch (error) {
    console.log(error);
  }
};
